import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import GlobalSettingMain from "Components/Setting/GlobalSettingMain";
// const GlobalSettingMain = React.lazy(() =>
//   import("Components/Setting/GlobalSettingMain")
// );

const GlobalSetting = () => {
  return (
    // <ContainerWrapper>
    <GlobalSettingMain />
    // </ContainerWrapper>
  );
};

export default GlobalSetting;
